document.querySelectorAll('.lookbook').forEach((lookbook) => {
  const track = lookbook.querySelector('.lookbook__track');
  const items = Array.from(lookbook.querySelectorAll('.lookbook__item'));
  const prevButton = lookbook.querySelector('.lookbook__arrow--prev');
  const nextButton = lookbook.querySelector('.lookbook__arrow--next');
  if (!track || items.length < 2) return;

  function scrollToNextItem(direction) {
    const trackRect = track.getBoundingClientRect();
    const currentScroll = track.scrollLeft;
    let target = items[items.length - 1];

    for (const item of items) {
      const offset = item.offsetLeft;
      if (direction > 0 && offset > currentScroll + 10) {
        target = item;
        break;
      }
      if (direction < 0 && offset < currentScroll - 10) {
        target = item;
      }
    }
    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }

  prevButton?.addEventListener('click', () => scrollToNextItem(-1));
  nextButton?.addEventListener('click', () => scrollToNextItem(1));
});
